// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse{50%{opacity:.5}}.dropdown-button__item{display:flex;align-items:flex-start;grid-gap:.5rem;gap:.5rem;color:#7a7a7a}.item__main-text{font-size:16px}.item__description-text,.item__main-text{font-style:normal;font-weight:400;line-height:18px}.item__description-text{font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
